import { render, staticRenderFns } from "./close-problem.vue?vue&type=template&id=ac4367d6&scoped=true&"
import script from "./close-problem.vue?vue&type=script&lang=js&"
export * from "./close-problem.vue?vue&type=script&lang=js&"
import style0 from "./close-problem.vue?vue&type=style&index=0&id=ac4367d6&prod&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac4367d6",
  null
  
)

export default component.exports